/* eslint-disable linebreak-style */
import {
  TOI_SUBS_COMMON_NUDGES_TRANSLATIONS_MWEB,
  TOI_SUBS_COMMON_NUDGES_TRANSLATIONS_WEB,
  TOI_PLUS_PLAN_TRANSLATION_MWEB,
  TOI_PLUS_PLAN_TRANSLATION_WEB,
} from 'constants/index';
import reducerRegistry from '../reducerRegistry';
import makeRequest from '../../utils/makeRequest';

const reducerName = 'translationConfig';
const createActionName = name => `toi/${reducerName}/${name}`;
export const RECEIVE_TRANSLATION_DATA = createActionName(
  'RECEIVE_TRANSLATION_DATA',
);
export const RECEIVE_NUDGE_DATA = createActionName('RECEIVE_NUDGE_DATA');
export const HANDLE_TOIP_TRANS_DATA_LOADING = createActionName(
  'HANDLE_TOIP_TRANS_DATA_LOADING',
);
export const HANDLE_DATA_ERROR = createActionName('HANDLE_DATA_ERROR');

function handleToipNudgesLoading(value) {
  //console.log('handle error');
  return {
    type: HANDLE_TOIP_TRANS_DATA_LOADING,
    payload: value,
  };
}

function handleError(error) {
  //console.log('handle error');
  return {
    type: HANDLE_DATA_ERROR,
    payload: error,
  };
}

export function getTranslationData(isWapView, countryCode) {
  let url = isWapView
    ? TOI_SUBS_COMMON_NUDGES_TRANSLATIONS_MWEB
    : TOI_SUBS_COMMON_NUDGES_TRANSLATIONS_WEB;
  url += `&cc=${countryCode}`;
  return makeRequest.get(url, {}, 'skipfeedengine');
}

function fetchTOIPlusNudgets(isMobile = false, countryCode = 'IN') {
  const experimentType =
    typeof window !== 'undefined' &&
    typeof window.abExperiment !== 'undefined' &&
    window.abExperiment;
  const experimentParam = experimentType ? `&abgroup=${experimentType}` : '';
  const nudgeUrl = `${
    isMobile ? TOI_PLUS_PLAN_TRANSLATION_MWEB : TOI_PLUS_PLAN_TRANSLATION_WEB
  }&cc=${countryCode}${experimentParam}`;
  return makeRequest.get(nudgeUrl);
}
function receiveTranslationData(data) {
  return {
    type: RECEIVE_TRANSLATION_DATA,
    payload: {
      data,
    },
  };
}

function receiveNudgeData(data) {
  return {
    type: RECEIVE_NUDGE_DATA,
    payload: {
      ...data,
    },
  };
}

export function loadTranslationData(isWapView, currencyCode) {
  return dispatch => {
    getTranslationData(isWapView, currencyCode)
      .then(response => {
        if (response && response.data) {
          dispatch(receiveTranslationData(response.data));
        }
      })
      .catch(error => dispatch(handleError(error)));
  };
}

export function loadNudgeData(isMobile, countryCode) {
  return dispatch => {
    dispatch(handleToipNudgesLoading('LOADING'));
    fetchTOIPlusNudgets(isMobile, countryCode)
      .then(data => {
        if (data?.data) {
          dispatch(handleToipNudgesLoading('DONE'));
          dispatch(receiveNudgeData(data?.data));
        } else {
          dispatch(handleToipNudgesLoading('ERROR'));
        }
      })
      .catch(() => {
        dispatch(handleToipNudgesLoading('ERROR'));
      });
  };
}

export default function reducer(state = {}, action) {
  switch (action.type) {
    case RECEIVE_TRANSLATION_DATA: {
      const { data } = action.payload;
      return {
        ...state,
        data,
      };
    }
    case RECEIVE_NUDGE_DATA: {
      const { gstForm, unifiedNodes } = action.payload;
      if (typeof window !== 'undefined' && window.sessionStorage) {
        if (gstForm && gstForm.startGstFlow) {
          sessionStorage.setItem('showGstfromNode', gstForm.startGstFlow);
        } else {
          sessionStorage.setItem('showGstfromNode', false);
        }
        if (unifiedNodes?.preExpiry?.renewNudgePeriod) {
          sessionStorage.setItem(
            'renewNudgePeriod',
            unifiedNodes?.preExpiry?.renewNudgePeriod,
          );
        } else {
          sessionStorage.setItem('renewNudgePeriod', 30);
        }
      }
      return {
        ...state,
        nudges: action.payload,
      };
    }
    case HANDLE_TOIP_TRANS_DATA_LOADING: {
      return {
        ...state,
        transLoading: action.payload,
      };
    }

    default:
      return state;
  }
}

reducerRegistry.register(reducerName, reducer);
